//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import ListagemPage from '../../components/templates/ListagemPage';
import { tableHelper } from '../../helpers/tableHelper';
import withAbility from '../../hoc/withAbility';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import { pedidoDevolucaoService } from '../../services/pedidoDevolucao.service';
import PedidoDevolucaoCrudListFilter from './PedidoDevolucaoCrudListFilter';

const endPoint = '/pedidoDevolucao/novo/';
const endPointView = '/pedidoDevolucao/';

class PedidoDevolucaoCrudList extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);

    const isSudo = props.user && props.user.perfis.includes('SUDO');

    this.columns = [
      { path: 'id', title: 'ID', isKey: true, dataSort: false, hidden: true },

      {
        path: 'status',
        title: 'Status',
        dataSort: false,
        isStatusPedido: true,
        width: '150px',
      },
      {
        path: 'numeroPedido',
        title: 'Número do pedido',
        dataSort: false,
        className: 'txtBold',
      },
      {
        path: 'createdAt',
        title: 'Data Criação',
        isDateTime: true,
        dataSort: false,
        width: '200px',
        className: 'txtBold',
      },
      // {
      //   path: 'urgente',
      //   title: 'É urgente',
      //   isKey: false,
      //   dataSort: false,
      //   yesNo: true,
      //   className: 'txtBold',
      // },
      ...(isSudo
        ? [{ path: 'clienteNomeFantasia', title: 'Cliente', dataSort: false }]
        : []),
      {
        path: 'pontoAtendimentoNome',
        title: 'Ponto Atendimento',
        dataSort: false,
        className: 'txtBold',
      },
      {
        path: 'tipoPedido',
        title: 'Tipo do pedido',
        isKey: false,
        dataFormat: () => 'Devolução',
        dataSort: false,
      },
      { path: 'responsavel', title: 'Responsável', dataSort: false },
      { path: 'criadoPorNome', title: 'Criado por', dataSort: false },
      { path: 'aprovadoPorNome', title: 'Aprovado por', dataSort: false },
      {
        path: 'urgente',
        title: 'É urgente',
        isKey: false,
        dataSort: false,
        yesNo: true,
        className: 'txtBold',
      },
    ];

    const fields = this.columns.map((col) => col.path);
    const labels = this.columns.map((col) => col.title);

    this.state = { labels, fields };
  }

  handleRowClick = (row: e) => {
    if (this.props.ability.can('update', 'PedidoDevolucao')) {
      this.props.history.push(endPointView + row.id);
    }
  };

  handleNewButton = () => {
    this.props.history.push(endPoint);
  };

  render() {
    const fields = this.state.fields;

    const tableColumn = _.map(this.columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={
          column.dataFormat ||
          ((cell, row, _extra, i) =>
            tableHelper.renderCustom(cell, row, column, i)) // mantém seu extraData
        }
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente mainTitle="Pedidos de Devolução" canBack={false} />
        <ListagemPage
          key="pedido-devolucao"
          pageFilter="pedido-devolucao"
          newButtonActionClick={this.handleNewButton}
          delete={() => {}}
          service={pedidoDevolucaoService}
          showNewButton={this.props.ability.can('create', 'PedidoDevolucao')}
          labelNewButton="Novo Pedido de Devolução"
          defaultOrder={'createdAt'}
          defaultDirection={'desc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={PedidoDevolucaoCrudListFilter}
          fields={fields}
          array={'pedidoDevolucao'}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return { user };
}

export default connect(mapStateToProps)(withAbility(PedidoDevolucaoCrudList));
